var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "sc-page-base",
        { attrs: { loading: _vm.loading, title: _vm.title } },
        [
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c(
                  "sc-button",
                  {
                    attrs: { theme: "primary" },
                    on: {
                      click: function($event) {
                        _vm.getTableGereratedQuoteContract()
                      }
                    }
                  },
                  [_vm._v("\n          Atualizar lista\n        ")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "sc-table",
                    {
                      staticClass: "sc-files__table",
                      attrs: {
                        data: _vm.extrationTable,
                        bordered: true,
                        hoverable: false,
                        draggable: "",
                        "show-detail-icon": true
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "filters",
                          fn: function(ref) {
                            var filters = ref.filters
                            return [
                              _c("div", { staticClass: "columns" }, [
                                _vm._v(
                                  "\n                sdfdsfdsfdsfdsf\n              "
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c(
                                "sc-table-column",
                                {
                                  attrs: {
                                    field: "download_url",
                                    label: "Arquivo"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(props.row.file_name) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "sc-table-column",
                                {
                                  attrs: {
                                    field: "contract_id",
                                    label: "ID do Contrato",
                                    sortable: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(props.row.contract_id) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "sc-table-column",
                                {
                                  attrs: {
                                    field: "delivery_method_id",
                                    label: "ID de transportadora",
                                    sortable: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(props.row.delivery_method_id) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "sc-table-column",
                                { attrs: { width: "150" } },
                                [
                                  _c(
                                    "sc-button",
                                    { attrs: { theme: "primary" } },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "button-download",
                                          attrs: {
                                            href: props.row.download_url,
                                            download: ""
                                          }
                                        },
                                        [_vm._v("Download")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c(
                        "template",
                        { attrs: { slot: "empty" }, slot: "empty" },
                        [_c("sc-table-empty")],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df92bdc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df92bdc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/table-quote/PageExtrationTableQuote.vue
// module id = null
// module chunks = 